import styled from 'styled-components';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const Home = styled('div')({
    fontFamily: "Gotham"
});

export const Section = styled('div')({
    backgroundColor: "#E2D3BA",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "120px",
    paddingRight: "120px",
    paddingTop: "60px",
    paddingBottom: "60px",

    [MediaQuery[Size.XXL]]: {
        paddingLeft: "90px",
        paddingRight: "90px",
    },

    [MediaQuery[Size.XL]]: {
        paddingLeft: "60px",
        paddingRight: "60px",
    },
    [MediaQuery[Size.NAV]]: {
        flexDirection: "column",
        paddingLeft: "20px",
        paddingRight: "20px",
    },
});

export const SectionTitle = styled('div')({
    fontSize: "40px",
    lineHeight: "50px",
    fontWeight: 400,
    width: "40%",
    textAlign: "center",
    marginRight: "5%",
    [MediaQuery[Size.NAV]]: {
        textAlign: "left",
        width: "90%",
        marginRight: "0%",
    },
});

export const SectionContent = styled('div')({
    width: "50%",
    fontSize: 20,
    marginLeft: "5%",

    [MediaQuery[Size.XL]]: {
        marginLeft: "0%",
    },
    [MediaQuery[Size.NAV]]: {
        width: "90%",
        marginLeft: "0%",
    },
});

